module.exports = __webpack_public_path__ + "static/Integris Software-9446e7ed56b7c676e7fc24e21e23698e.jpg";